<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-5">
        <div class="card h-100">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between">
              <h6 class="mb-0">Detalles de Finalización</h6>
              <span :class="['badge badge-sm', statusBadge(task.status)]">{{ task.status }}</span>
            </div>
          </div>
          <div v-if="loading" class="card-body text-center">
            <div class="spinner-border text-primary" role="status"></div>
          </div>
          <div v-else class="card-body">
            <div class="mb-4">
              <p class="text-xs font-weight-bold text-uppercase text-muted mb-1">Tipo de Gestión</p>
              <h6 class="text-sm">{{ task.type_name }}</h6>
              <p class="text-xs ">{{ task.description }}</p>
            </div>

            <div class="row mb-4">
              <div class="col-4">
                <p class="text-xs font-weight-bold text-uppercase text-muted mb-1">Fecha Límite</p>
                <span class="text-xs ">{{ task.due_date }}</span>
              </div>
              <div class="col-4">
                <p class="text-xs font-weight-bold text-uppercase text-muted mb-1">Completada el</p>
                <span class="text-xs ">{{ task.completed_at }}</span>
              </div>
              <div class="col-4 text-end">
                <p class="text-xs font-weight-bold text-uppercase text-muted mb-1">Prioridad</p>
                <span :class="['badge badge-xs', priorityBadge(task.priority)]">{{ task.priority }}</span>
              </div>
              <template v-if="task.task_type==1|| task.task_type==6">
                <div class="col-4">
                  <p class="text-xs font-weight-bold text-uppercase text-muted mb-1">A Cobrar</p>
                  <span class="text-xs ">{{ task.to_collect }}</span>
                </div>
                <div class="col-4">
                  <p class="text-xs font-weight-bold text-uppercase text-muted mb-1">Recuperado</p>
                  <span class="text-xs ">{{ task.collected }}</span>
                </div>
              </template>
            </div>

            <div class="bg-gray-100 p-3 border-radius-lg mb-4">
              <p class="text-xs font-weight-bold text-uppercase mb-1">Evidencia Fotográfica</p>
              <img v-if="task.evidence_url" :src="task.evidence_url" class="img-fluid border-radius-lg shadow-sm mt-2" alt="Evidencia de campo" />
              <div v-else class="text-center py-4 bg-white border-radius-md border">
                <i class="fa fa-image text-secondary mb-2"></i>
                <p class="text-xs mb-0">Sin foto adjunta</p>
              </div>
            </div>

            <div class="mb-0">
              <p class="text-xs font-weight-bold text-uppercase text-muted mb-1">Notas del Usuario</p>
              <p class="text-sm font-italic border-start ps-3 py-1 bg-light border-radius-sm">
                {{ task.user_notes || 'El usuario no agregó notas.' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-7 mt-lg-0 mt-4">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6 class="mb-0">Análisis de Ubicación</h6>
            <p class="text-xs">Comparativa entre punto planeado y ejecución real</p>
          </div>
          <div class="card-body">
            <div id="view-map" class="border-radius-lg shadow-sm" style="height: 450px; z-index: 1;"></div>

            <div class="mt-4 row">
              <div class="col-md-6">
                <div class="d-flex align-items-center mb-2">
                  <i class="fa fa-map-marker text-secondary me-2"></i>
                  <span class="text-xs font-weight-bold">Punto Planificado (Administración)</span>
                </div>
                <p class="text-xxs  ms-4">{{ task.tlatitude }}, {{ task.tlongitude }}</p>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center mb-2">
                  <i class="fa fa-map-marker text-danger me-2"></i>
                  <span class="text-xs font-weight-bold">Punto de Cierre (Colaborador)</span>
                </div>
                <p class="text-xxs ms-4">{{ task.latitude || 'N/A' }}, {{ task.longitude || 'N/A' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import L from 'leaflet';

export default {
  name: "TaskView",
  data() {
    return {
      loading: true,
      task: {},
      map: null
    };
  },
  methods: {
    async fetchDetails() {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.get(`${this.$store.state.apiURL}task/details?id=${this.$route.params.id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        this.task = response.data;
        this.loading = false;
        this.$nextTick(() => {
          this.initMap();
        });
      } catch (e) {
        console.error("Error al cargar detalles", e);
      }
    },

    initMap() {
      if (!this.task.tlatitude || !this.task.tlongitude) return;

      const plannedPos = [parseFloat(this.task.tlatitude), parseFloat(this.task.tlongitude)];
      const executionPos = (this.task.latitude && this.task.longitude)
                           ? [parseFloat(this.task.latitude), parseFloat(this.task.longitude)]
                           : null;

      this.map = L.map('view-map').setView(plannedPos, 15);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap'
      }).addTo(this.map);

      // Icono Verde para lo planeado
      const greenIcon = L.icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41], iconAnchor: [12, 41]
      });

      // Icono Rojo para la ejecución
      const redIcon = L.icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41], iconAnchor: [12, 41]
      });

      L.marker(plannedPos, { icon: greenIcon }).addTo(this.map).bindPopup("Punto Planificado");

      if (executionPos) {
        L.marker(executionPos, { icon: redIcon }).addTo(this.map).bindPopup("Ubicación de Cierre");

        // Dibujamos una línea punteada entre ambos puntos para resaltar la distancia
        L.polyline([plannedPos, executionPos], { color: 'blue', weight: 2, dashArray: '5, 10' }).addTo(this.map);

        // Ajustamos el zoom para que se vean ambos marcadores
        const group = new L.featureGroup([L.marker(plannedPos), L.marker(executionPos)]);
        this.map.fitBounds(group.getBounds().pad(0.5));
      }
    },

    priorityBadge(p) {
      if (p === 'High') return 'bg-gradient-danger';
      if (p === 'Medium') return 'bg-gradient-warning';
      return 'bg-gradient-info';
    },

    statusBadge(s) {
      if (s === 'Completed') return 'bg-gradient-success';
      if (s === 'Pending') return 'bg-gradient-secondary';
      return 'bg-gradient-primary';
    }
  },
  mounted() {
    this.fetchDetails();
  }
};
</script>

<style scoped>
#view-map { border: 1px solid #eee; background: #f8f9fa; }
</style>